import React from 'react';
import {Zap} from "lucide-react";
import {useAuth0} from "@auth0/auth0-react"
import {Button} from "../Button/Button";
import {NavigationToggle} from "../NavigationToggle/NavigationToggle";
import {useLocation, useNavigate} from "react-router-dom";

export interface NavbarProps extends React.HTMLAttributes<HTMLDivElement> {
}

export const Navbar = ({className, ...props}: NavbarProps) => {

    const {isAuthenticated, logout, user} = useAuth0();
    const location = useLocation();
    const navigate = useNavigate();

    const isDarkPage =
        location.pathname === "/slideshow" ||
        location.pathname === "/celebrations";

    const handleLogoClick = () => {
        navigate('/');
    };

    const handleLogout = () => {
        logout({
            logoutParams: {
                returnTo: window.location.origin,
            },
        });
    };

    const navBackground = isDarkPage ? 'bg-blue-950 shadow-md shadow-black/20 relative z-50' : 'bg-white shadow-md'

    const textColor = isDarkPage ? 'text-white' : 'text-blue-950';
    const subTextColor = isDarkPage ? 'text-blue-200' : 'text-gray-500';
    const userTextColor = isDarkPage ? 'text-gray-200' : 'text-gray-600';

    const logoutBtnStyles = isDarkPage ? 'bg-white text-blue-950 hover:bg-gray-100 border-transparent' : '';

    const baseStyles = 'w-full px-3 md:px-6 py-3 md:py-4 transition-all duration-300';
    const combinedClassName = `${baseStyles} ${navBackground} ${className || ''} flex justify-between items-center`;

    return (
        <nav className={combinedClassName} {...props}>
            <div className="flex items-center gap-2 md:gap-4">

                {/* Logo/Icon */}
                <div
                    className="flex items-center justify-center w-9 h-9 bg-gradient-to-br from-blue-500 to-orange-400 rounded-lg shadow-md cursor-pointer"
                    onClick={handleLogoClick}
                >
                    <Zap className="w-5 h-5 text-white"/>
                </div>

                <div className="hidden sm:flex flex-col leading-tight">
                    <span className={`font-bold text-base md:text-lg ${textColor}`}>PowerUp</span>
                    <span className={`text-sm ${subTextColor}`}>
                        Recognition Platform
                    </span>
                </div>
                </div>

            <NavigationToggle isDarkTheme={isDarkPage}/>

            {isAuthenticated && (
                <div className="flex items-center gap-4">

                    {user?.picture && (
                        <img
                            src={user.picture}
                            alt={user.name}
                            className="w-9 h-9 rounded-full object-cover border border-gray-300 dark:border-white/30 shadow-sm transition-transform duration-200 hover:scale-105"
                        />
                    )}

                    <span className={`${userTextColor} hidden sm:block`}>{user?.name}</span>

                    <Button
                        variant="default"
                        onClick={handleLogout}
                        className={`px-2 md:px-4 py-1 md:py-2 text-xs md:text-sm ${logoutBtnStyles}`}
                    >
                        Logout
                    </Button>

                </div>
            )}
        </nav>
    );
};
